import { Component, Vue } from 'vue-property-decorator'
import { mapActions, mapState } from 'vuex'
import { Spinner } from '@kwixeo/interface-vue'

@Component({
  methods: {
    ...mapActions('tickets', ['loadTags', 'loadCategories'])
  },
  computed: {
    ...mapState('tickets', ['tags', 'categories'])
  },
  components: {
    Spinner
  }
})
export default class LoadTicketElements extends Vue {
  loadTags!: (state?: boolean) => void
  tags!: KwixeoTickets.Tags
  loadCategories!: (state?: boolean) => void
  categories!: KwixeoTickets.Categories

  protected loading = false

  async mounted (): Promise<void> {
    this.loading = true
    await this.loadTags()
    await this.loadCategories()
    this.loading = false
  }
}
